import React, { useState } from "react";
import { Modal, Button, Row, Select, Col } from "antd";
import { FormattedMessage } from "react-intl";
const { Option } = Select;
const OrdersActionConfirmModal = ({
  isAdminOrders,
  onActionDone,
  onCancel,
  visible,
  orders,
  jobs,
  removeOrdersFromJob,
  addOrdersToJob,
  afterClose,
}: {
  isAdminOrders: boolean;
  onActionDone: any;
  onCancel: () => React.Dispatch<React.SetStateAction<boolean>>;
  visible: { id: string; open: boolean };
  orders: number[];
  jobs: { jobId: number }[];
  afterClose: () => React.Dispatch<React.SetStateAction<[]>>;

  removeOrdersFromJob: ({ jobId, ordersIds }: { jobId: number; ordersIds: number[] }) => Promise<void>;
  addOrdersToJob: ({ jobId, ordersIds }: { jobId: any; ordersIds: any }) => Promise<void>;
}) => {
  const [selectedJob, onSelectJob] = useState<number>();
  const renderMessage = (type: string) => {
    if (type === "remove") {
      return <p>Do you really want to remove these orders from jobs ?</p>;
    } else {
      return (
        <>
          <p>Do you really want to assign these orders to job ?</p>
          <br />
          <Row>
            <label>Please select a job to assign these jobs</label>

            <Select
              defaultValue={selectedJob}
              onSelect={(value: number) => onSelectJob(value)}
              placeholder="Select Job Id"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                return (option!.children as unknown as number).toString().toLowerCase().includes(input.toLowerCase());
              }}
            >
              {jobs?.map(({ jobId }) => (
                <Option value={jobId} key={jobId}>
                  Job n° {jobId}
                </Option>
              ))}
            </Select>
          </Row>
        </>
      );
    }
  };
  return (
    <Modal
      width={300}
      key={"upload-orders-modal"}
      visible={visible.open}
      onCancel={onCancel}
      closable={false}
      className="upload-orders-modal"
      title={<FormattedMessage id="button.orders.confirm" defaultMessage="Action Confirmation" />}
      footer={null}
      afterClose={afterClose}
    >
      <div className="mobile-confirm-modal-body">
        <div className="mobile-confirm-modal-body__title">{renderMessage(visible.id)}</div>

        {orders?.length ? (
          <></>
        ) : (
          <Col>
            <p style={{ fontWeight: "500", color: "red" }}>Selected Orders can't be assigned to jobs !</p>
            <p style={{ fontWeight: "500", color: "gray", fontSize: "small" }}>
              Please filter by <b>'Can be assigned'</b> and select other orders !
            </p>
          </Col>
        )}
        <Button onClick={onCancel} key="cancel" className="mobile-btn mobile-btn--white">
          <FormattedMessage id="tabPane.actions.cancel" defaultMessage="Cancel" />
        </Button>

        <Button
          key="remove"
          onClick={() => {
            removeOrdersFromJob({ jobId: 1, ordersIds: orders });
            onActionDone();
          }}
          disabled={!orders?.length}
          hidden={visible.id === "remove" ? false : true}
          className="mobile-btn mobile-btn--yellow"
        >
          <FormattedMessage id="tabPane.actions.confirm" defaultMessage="Confirm" />
        </Button>

        <Button
          key="add"
          onClick={() => {
            addOrdersToJob({ jobId: selectedJob, ordersIds: orders });
            onActionDone();
          }}
          disabled={!orders?.length || !selectedJob}
          hidden={visible.id === "add" ? false : true}
          className="mobile-btn mobile-btn--yellow"
        >
          <FormattedMessage id="tabPane.actions.confirm" defaultMessage="Confirm" />
        </Button>
      </div>
    </Modal>
  );
};

export default OrdersActionConfirmModal;
